
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component({
    components: {
    }
  })

  export default class General extends Vue  {
    dialog = false
    editDateMenu = false
    menu = false
    expanded = []
    headers = [
      { text: 'Date', value: 'date' },
      { text: 'Type 3', value: 'type_three' },
      { text: 'Type 3S2', value: 'type_threestwo' },
      { text: 'Type 3-3', value: 'type_threethree' },
      { text: 'Speed (MPH)', value: 'speed' },
      { text: 'Bridge Posting', value: 'bridge_posting' },
      { text: 'Permit Rating', value: 'rating' },
      //{ text: 'URL', value: 'url' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]
    loads: any = [
      { text: 'Legal', value: 1 },
    ]
    postings: any = [
      { text: '5 at/above Legal Loads', value: 1 },
    ]
    ratingRules: any = [
      ( v: any ) => ( !v || (v && v.length <= 10)) || 'Rating must be less than 10 characters',
    ]
    items: Array<object> = []
    editedIndex = -1
    editedItem: any = {
      id: null,
      date: null,
      type_three: '',
      type_threestwo: '',
      type_threethree: '',
      speed: '',
      bridge_posting: '',
      rating: '',
      comments: '',
      bridgeId: -1
    }
    defaultItem: any = {
      id: null,
      date: null,
      type_three: '',
      type_threestwo: '',
      type_threethree: '',
      speed: '',
      bridge_posting: '',
      rating: '',
      comments: '',
      bridgeId: -1
    }
    @Prop() readonly id!: object
    @Prop() readonly tab!: number

    //Methods
    public addNewRating(): void {
      this.dialog = true
    }

    public editItem(item: object ): void {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    }

    public close(): void {
      this.dialog = false
      this.$store.commit('bridge/setMsg', "")
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }

    public deleteItem(item: object): void {
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteBridgePermitRating', item)
    }

    public save(): void {
      this.editedItem.bridgeId = this.id
      if (this.editedIndex > -1) {
        this.$store.dispatch('bridge/updateBridgePermitRating', this.editedItem)
        //Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.$store.dispatch('bridge/storeBridgePermitRating', this.editedItem)
        //this.items.push(this.editedItem)
      }
      this.close()
    }

    //Getters
    get getBridgePermitRatings(): any {
      return this.$store.getters['bridge/getBridgePermitRatings']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getLoading(): boolean {
      return this.$store.getters['bridge/getLoading']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watchers
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.tab == 7) {
        this.$store.dispatch('bridge/getBridgePermitRatings', { id: this.id })
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getBridgePermitRatings')
    setItems(val: any) {
      this.items = val
    }
  }



